
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

export default BaseCmsBlock.extend({
    name: 'InformationSquareMetersBlock',

    methods: {
        formatSquare(number) {
            if (+number % 1 === 0) {
                return this.$numberFormat(number);
            }

            return number;
        },
    },
});
